<script lang="ts">
	import { _ } from 'svelte-i18n';
	import { page } from '$app/stores';
	import FastBtn from '$lib/component/fast-btn.svelte';
	import Footer from '$lib/component/footer.svelte';
	import Navbar from '$lib/component/navbar.svelte';
	import Partner from '$lib/component/partner.svelte';
	import { initHeroHomeSwiper } from '$lib/js/script.js';
	import { onMount } from 'svelte';

	import type { PageServerData } from './$types';
	export let data: PageServerData;

	const lang = $page.params.locale;

	let wedding = data?.wedding ?? [];
	let partner = data?.partner ?? [];
	let award = data?.award ?? [];

	onMount(() => {
		initHeroHomeSwiper();

		const script = document.createElement('script');
		script.src = 'https://unpkg.com/@phosphor-icons/web';
		script.async = true;
		document.head.appendChild(script);
	});
</script>

<svelte:head>
	<title>Weddings - Holiday Inn Resort Bali Nusa Dua</title>
	<link rel="canonical" href="https://balinusadua.holidayinnresorts.com/en/events" />
</svelte:head>

<Navbar />

<FastBtn />

<section id="rooms">
	<div id="hero-banner" class="container-fluid p-0">
		<div class="w-100 h-100 p-md-0 p-0 position-relative overflow-hidden">
			<div class="swiper w-100 h-100 slider-hero-wedding">
				<div class="swiper-wrapper">
					{#each wedding as wedding}
					<div class="swiper-slide">
						<img
							alt="Holiday Inn Resorts Nusa Dua"
							src={wedding.featured_images[0].path}
							class="w-100 h-100 object-fit-cover"
						/>
					</div>
					{/each}
				</div>
			</div>
			<div id="hero-text" class="position-absolute top-0 start-0 w-100 h-100 z-3"></div>
		</div>
	</div>

	<div class="container-fluid py-md-5 py-5 px-0 rooms-welcome position-relative">
		<div class="row g-0 justify-content-center mt-md-5 mt-4 mb-md-5 mb-5">
			<div class="col-md-10 px-md-5 px-3 text-center">
				<p class="mb-md-3 display-5 pe-md-3 ff-lola-bir lh-2">{$_('wedding_title_1')}</p>
				<p class="line mb-md-4 mb-3 mx-auto"></p>
				<p class="ff-helvetica mb-md-4 mb-3">
					{@html $_('wedding_desc_1')}
				</p>
				<p class="text-center">
					<a
						href="https://balinusadua.holidayinnresorts.com/cms/storage/app/media/Wedding-Booklet-HIRBND.pdf"
						target="_blank"
						class="btn main-btn-wedding px-4 py-2 rounded-3">{$_('btn_wedding_booklet')}</a
					>
				</p>
			</div>
		</div>
		<div class="row g-0">
			{#each wedding as wedding, index}
				{#if index % 2 === 0}
					<div class="col-md-12 row g-0 py-md-5 align-items-center mb-4">
						<div class="col-md-6 px-md-0 px-0">
							<div class="ratio ratio-4x3 d-none d-md-block">
								<img
									alt="Holiday Inn Resort Nusa Dua"
									src={wedding?.featured_images[0].path}
									class="w-100 h-100 object-fit-cover"
								/>
							</div>
							<div class="ratio ratio-1x1 d-block d-md-none">
								<img
									alt="Holiday Inn Resort Nusa Dua"
									src={wedding?.featured_images[0].path}
									class="w-100 h-100 object-fit-cover"
								/>
							</div>
						</div>
						<div class="col-md-5 p-md-0 p-4 position-relative">
							<div class="p-md-5 p-3 py-4 content-right bg-white text-center text-md-start">
								<p class="mb-md-3 fs-1 pe-md-3 ff-lola-bir lh-1">{wedding?.name}</p>
								<p class="line mb-md-4 mb-3 mx-auto mx-md-0"></p>
								<p class="ff-helvetica mb-4">{wedding?.excerpt}</p>
								<p class="text-center text-md-start">
									<a
										href="mailto:widiastuti.diah@ihg.com"
										target="_blank"
										class="btn main-btn-wedding px-4 py-2 rounded-3 me-2 mb-2">{$_('btn_enquire')}</a
									>
									<a
										role="button"
										data-bs-toggle="modal"
										data-bs-target="#detail-{wedding?.slug}"
										class="btn main-btn-wedding-outline px-4 py-2 rounded-3 me-2 mb-2">{$_('btn_view_details')}</a
									>
								</p>
							</div>
						</div>
					</div>
				{:else}
					<div class="col-md-12 row g-0 py-md-5 align-items-center mb-4">
						<div class="col-md-5 offset-md-1 order-md-1 order-2 p-md-0 p-4 position-relative">
							<div class="p-md-5 p-3 py-4 content-left bg-white text-center text-md-start">
								<p class="mb-md-3 fs-1 pe-md-3 ff-lola-bir lh-1">{wedding?.name}</p>
								<p class="line mb-md-4 mb-3 mx-auto mx-md-0"></p>
								<p class="ff-helvetica mb-4">{wedding?.excerpt}</p>
								<p class="text-center text-md-start">
									<a
										href="mailto:widiastuti.diah@ihg.com"
										target="_blank"
										class="btn main-btn-wedding px-4 py-2 rounded-3 me-2 mb-2">{$_('btn_enquire')}</a
									>
									<a
										role="button"
										data-bs-toggle="modal"
										data-bs-target="#detail-{wedding?.slug}"
										class="btn main-btn-wedding-outline px-4 py-2 rounded-3 me-2 mb-2">{$_('btn_view_details')}</a
									>
								</p>
							</div>
						</div>
						<div class="col-md-6 px-md-0 px-0 order-md-2 order-1">
							<div class="ratio ratio-4x3 d-none d-md-block">
								<img
									alt="Holiday Inn Resort Nusa Dua"
									src={wedding?.featured_images[0].path}
									class="w-100 h-100 object-fit-cover"
								/>
							</div>
							<div class="ratio ratio-1x1 d-block d-md-none">
								<img
									alt="Holiday Inn Resort Nusa Dua"
									src={wedding?.featured_images[0].path}
									class="w-100 h-100 object-fit-cover"
								/>
							</div>
						</div>
					</div>
				{/if}

				<div
					class="modal fade"
					id="detail-{wedding?.slug}"
					tabindex="-1"
					aria-labelledby="exampleModalLabel"
					aria-hidden="true"
				>
					<div class="modal-dialog modal-dialog-centered modal-lg">
						<div class="modal-content">
							<div class="modal-body">
								<div class="row g-0">
									<div class="col-md-12">
										<p class="text-end">
											<button
												type="button"
												class="btn-close"
												data-bs-dismiss="modal"
												aria-label="Close"
											></button>
										</p>
										<p class="mb-md-4 mb-3 fs-1 ff-lola-bir lh-1">{wedding?.name}</p>
										<div class="ff-helvetica mb-md-5 mb-4">
											{@html wedding?.description}
										</div>
										<p class="mb-0">
											<a
												href="mailto:guestservices.hirnusadua@ihg.com"
												target="_blank"
												class="btn main-btn-wedding px-4 py-2 fw-medium ff-helvetica rounded-3 me-3"
												>{$_('btn_enquire')}</a
											>
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			{/each}
		</div>
	</div>
</section>

<Partner {partner} />

<Footer {award} />

<style>
	.main-btn-wedding {
    background-color: #e0f0ff;
    color: #000000;
    transition: 0.3s all;
	}

	.main-btn-wedding:hover {
		background-color: #1c4b34;
		color: white;
		transition: 0.3s all;
	}

	.main-btn-wedding-outline {
		border: 1px solid #e0f0ff;
		color: #000000;
		transition: 0.3s all;
	}

	.main-btn-wedding-outline:hover {
		border: 1px solid #e0f0ff;
		background-color: #9bc5b7;
		color: white;
		transition: 0.3s all;
	}
	#hero-text {
		background-color: rgba(0, 0, 0, 0.3);
	}
	.rooms-welcome::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		z-index: -1;
		margin-bottom: -2px;
		background-image: linear-gradient(
				to top,
				rgba(255, 255, 255, 1),
				rgba(255, 255, 255, 0.85),
				rgba(255, 255, 255, 0.8)
			),
			url('/img/bg-home-1.jpg');
		background-position: center;
		background-size: cover;
	}

	.line {
		border-bottom: 2px solid #000000;
		width: 25%;
	}
	.rooms-welcome .content-right {
		margin-left: -10%;
		box-shadow: 10px 10px 0px #e0f0ff;
	}
	.rooms-welcome .content-left {
		margin-right: -10%;
		box-shadow: -10px 10px 0px #e0f0ff;
		position: relative;
		z-index: 3;
	}
	/* .featured-amenities .icon {
		background-color: #e6e9f8;
		color: #451C70;
		border-radius: 100%;
		width: 40px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
	} */
	@media (max-width: 600px) {
		/* .rooms-welcome .right-content-rooms:before {
			content: unset;
		} */
		.rooms-welcome .content-right {
			margin-top: -35%;
			margin-left: 0%;
			box-shadow: 10px 10px 0px #e0f0ff;
		}
		.rooms-welcome .content-left {
			margin-top: -35%;
			margin-right: 0%;
			box-shadow: 10px 10px 0px #e0f0ff;
		}
	}
</style>
